const localizedDate = date => new Date(date).toLocaleDateString('en', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});

export default localizedDate;
